<template>
    <FormSection>
        <template v-slot:title>
            {{ $tc('messages.activities', 2) }}
        </template>
        <template v-slot:content>
            <form action="" @submit.prevent="submit()">
                <div class="px-4 py-5 sm:p-6">
                    <div class="md:grid md:grid-cols-12 md:gap-6">
                        <div class="sm:col-span-6">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.max_score')" for="max_score" />
                                <FormInput
                                    required
                                    id="max_score"
                                    v-model="form.max_score"
                                    name="max_score"
                                    type="number"
                                    step="1"
                                    class="mt-1"
                                />
                                <FormError :value="form.errors.max_score" class="mt-2" />
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow sm:rounded-bl-md sm:rounded-br-md"
                >
                    <div class="mt-1">
                        <AppButton element="button" type="submit" desired-action>
                            {{ $t('messages.save') }}
                            <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                        </AppButton>
                    </div>
                </div>
            </form>
        </template>
    </FormSection>
</template>

<script>
import FormSection from '@/components/FormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'UpdateActivityPreferencesForm',
    components: {
        FormSection,
        FormLabel,
        FormInput,
        FormError,
        AppButton,
    },
    props: ['activity', 'url'],
    data() {
        return {
            form: this.$inertia.form({
                key: 'activity',
                settings: ['max_score'],
                max_score: this.activity.max_score,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.url, {
                preserveScroll: true,
            });
        },
    },
};
</script>
